import IncrementalitySetupTab from "features/incrementality/components/IncrementalitySetupTab";

function IncrementalitySetupPage() {
  return <IncrementalitySetupTab />;
}

export default IncrementalitySetupPage;
